import {
  CLEAR_PROGRAMS,
  GET_PROGRAMS
} from './constants';

export function loadPrograms(service, status) {
  const queryParams = { service };

  if (typeof status === 'boolean') {
    queryParams.done = status;
  }

  return dispatch => dispatch({
    type: GET_PROGRAMS,
    request: {
      method: 'GET',
      endpoint: 'programs/',
      queryParams
    }
  });
}

export function clearPrograms() {
  return dispatch => dispatch({
    type: CLEAR_PROGRAMS
  });
}



// WEBPACK FOOTER //
// ./src/redux/Programs/actions.js